import {Component, Input, } from '@angular/core';
import {FirebaseService} from '../app/firebase.service';
import {RechnungItems} from '../app/types';
import {User} from '../app/user';

@Component({
  selector: 'app-kunde-buchungen',
  templateUrl: './kunde-buchungen.component.html',
  styles: []
})
export class KundeBuchungenComponent {
  items: RechnungItems;

  constructor(public service: FirebaseService) { }

  @Input()
  set user(user: User) {
    if (!user) {
      this.items = null;
      return;
    }
    user.rechnung.subscribe(rechnung => {
      this.items = rechnung ? rechnung.alleItems : null;
    });
  }
}
